module.exports = __webpack_public_path__ + "img/iuv-bg.90559a1a.png";